<template>
  <div>
    <div class="general-tab-part supervisor-tab">
      <div
        @click="selectSynthesize()"
        class="tab-item"
        :class="{ selected: currentTab == '1' }"
      >
        {{ selectedSynthesizeText }}
        <img
          v-if="currentTab != '1'"
          src="../../../assets/icon-supervisor-sort-down.png"
        />
        <img
          class="active"
          v-if="currentTab == '1' && isSelectSynthesize"
          src="../../../assets/icon-supervisor-sort-up1.png"
        />
        <img
          class="active"
          v-if="currentTab == '1' && !isSelectSynthesize"
          src="../../../assets/icon-supervisor-sort-down1.png"
        />
      </div>
      <div
        @click="selectArea()"
        class="tab-item"
        :class="{ selected: currentTab == '2' }"
      >
        {{ selectedAreaText }}
        <img
          v-if="currentTab != '2'"
          src="../../../assets/icon-supervisor-sort-down.png"
        />
        <img
          class="active"
          v-if="currentTab == '2' && isSelectArea"
          src="../../../assets/icon-supervisor-sort-up1.png"
        />
        <img
          class="active"
          v-if="currentTab == '2' && !isSelectArea"
          src="../../../assets/icon-supervisor-sort-down1.png"
        />
      </div>
    </div>
    <div class="select-part" v-if="showSelectPart && isSelectSynthesize">
      <div class="select-list">
        <div
          class="select-item"
          v-for="synthesizeItem in synthesizeList"
          :class="{ selected: synthesizeItem.value == synthesize }"
          @click="updateSynthesize(synthesizeItem, '1')"
        >
          {{ synthesizeItem.text }}
        </div>
      </div>
    </div>
    <div class="select-part" v-if="showSelectPart && isSelectArea">
      <div class="area-select-list">
        <div
          class="select-item"
          v-for="area in areaList"
          :class="{ selected: area.id == selectedAreaId }"
          @click="updateArea(area, '1')"
        >
          {{ area.name }}
        </div>
      </div>
    </div>
    <template v-if="gangmasterList.length != 0">
      <div
        class="supervisor-item"
        v-for="(foreman, index) in gangmasterList"
        :style="index === 0 ? 'paddingTop:0' : ''"
      >
        <img
          class="supervisor-avatar"
          :src="imgUrl + foreman.avatar"
          @click="DetailGangmaster(foreman)"
        />
        <div class="supervisor-info" @click="DetailGangmaster(foreman)">
          <div class="first-line">
            <div class="left">
              <div class="name">{{ foreman.name }}</div>
            </div>
          </div>
          <div class="appointment-info">
            <img src="../../../assets/icon-appointment-num.png" />预约名额<span
              class="num"
              >{{ foreman.spares }}</span
            >
          </div>
          <div class="less-info">
            <div class="case-info" v-if="foreman.deposit">
              <img src="../../../assets/icon-app-deposit.png" />订金<span
                class="num deposit"
                >{{ foreman.deposit }}</span
              >
            </div>
          </div>
        </div>

        <div
          v-if="foreman.spares != 0"
          class="appoint-btn"
          @click="openGangmasterReservation(foreman)"
        >
          预 约
        </div>
        <div
          v-if="foreman.spares == 0"
          class="full-btn"
          @click="openGangmasterReservation(foreman)"
        >
          已 满
        </div>
      </div>
    </template>
    <div v-else class="black-page">
      <img src="../../../assets/icon-no-img.png" />
      <div class="tip">暂无工长信息!</div>
    </div>
  </div>
</template>
<script>
import {imgUrl} from '../../../config'
import session from "../../../utils/Session";
import SupervisorService from "../../../service/SupervisorService";
import areaService from "../../../service/core/AreaService";

export default {
  name: "SupervisorList",
  data() {
    return {
      selectedAreaText: "接单区域",
      selectedSynthesizeText: "综合排序",
      partAreaText: "接单区域",
      partSynthesizeText: "综合排序",
      gangmasterList: [],
      synthesize: "0",
      selectedAreaId: "",
      synthesizeList: [
        { value: 0, text: "综合排序" },
        { value: 1, text: "评价优选" },
        { value: 2, text: "成单数由高到低" },
        { value: 3, text: "案例由高到低" },
        { value: 4, text: "案例由低到高" },
      ],
      areaList: [],
      showSelectPart: false,
      isSelectArea: false,
      isSelectSynthesize: false,
      currentTab: "1",
      imgUrl: imgUrl,
    };
  },
  beforeMount() {
    this.getGangmasterList();
    this.loadAreaList();
  },
  methods: {
    async loadAreaList() {
      let result = await areaService.getAreaList(2);
      this.areaList = result.data;
    },
    async getGangmasterList() {
      let result = await SupervisorService.getSupervisorList(
        "2",
        this.synthesize,
        this.selectedAreaId,
        "3"
      );
      if (result.code == 0) {
        this.gangmasterList = [];
        if (this.synthesize != 0) {
          this.gangmasterList = result.data;
        } else {
          let closeSwitchForemans = [];
          let withoutSparesForemans = [];
          for (let foreman of result.data) {
            if (foreman.appointmentSwitch != 1 && foreman.spares != x) {
              closeSwitchForemans.push(foreman);
            } else if (foreman.spares == 0) {
              withoutSparesForemans.push(foreman);
            } else {
              this.gangmasterList.push(foreman);
            }
          }
          this.gangmasterList = this.gangmasterList.concat(closeSwitchForemans);
          this.gangmasterList = this.gangmasterList.concat(
            withoutSparesForemans
          );
        }
        for (let supervisor of this.gangmasterList) {
          if (supervisor.decorateType) {
            let decorateTypeArr = supervisor.decorateType.split(",");
            this.$set(supervisor, "decorateTypeArr", decorateTypeArr);
          }
        }
      } else {
        Toast("获取工长列表信息失败");
      }
    },
    openGangmasterReservation(gangmaster) {
      if (gangmaster.appointmentSwitch != "1") {
        Toast("该工长暂时不接受预约!");
      } else if (
        gangmaster.appointmentSwitch == "1" &&
        gangmaster.spares == 0
      ) {
        Toast("该工长预约已满!");
      } else {
        if (!!this.global.isMiniProgrm) {
          session.isLogin().then((flag) => {
            if (flag) {
              wx.miniProgram.navigateTo({
                url: `/pages/gangmaster/reservation?id=${
                  gangmaster.id
                }&companyId=${gangmaster.companyId}&deposit=${
                  gangmaster.deposit
                }&supervisorName=${gangmaster.name}`,
              });
            } else {
              let backUrl = this.$route.fullPath;
              wx.miniProgram.navigateTo({
                url: `/pages/register/register?h5Url=${encodeURIComponent(
                  backUrl
                )}`,
              });
            }
          });
        } else {
          this.$router.push({
            name: "GangmasterReservation",
            query: {
              id: gangmaster.id,
              companyId: gangmaster.companyId,
              supervisorName: gangmaster.name,
              deposit: gangmaster.deposit,
            },
          });
        }
      }
    },
    DetailGangmaster(gangmaster){
        this.$router.push({name:'GangmasterDetail',query:{supervisorId:gangmaster.id,supervisorName:gangmaster.name}});
      },
    selectSynthesize() {
      this.showSelectPart = true;
      this.isSelectArea = false;
      this.isSelectDecorateType = false;
      this.isSelectSynthesize = !this.isSelectSynthesize;
      this.currentTab = "1";
    },
    async updateSynthesize(synthesize, decorateType) {
      this.showSelectPart = !this.showSelectPart;
      if (decorateType == "1") {
        this.synthesize = synthesize.value;
        this.selectedSynthesizeText = synthesize.text;
        this.getGangmasterList();
      } else {
        this.partSynthesize = synthesize.value;
        this.partSynthesizeText = synthesize.text;
        this.getForemanList();
      }
      this.isSelectSynthesize = !this.isSelectSynthesize;
    },
    selectArea() {
      this.showSelectPart = true;
      this.isSelectSynthesize = false;
      this.isSelectDecorateType = false;
      this.isSelectArea = !this.isSelectArea;
      this.currentTab = "2";
    },
    async updateArea(area, decorateType) {
      this.showSelectPart = !this.showSelectPart;
      if (decorateType == "1") {
        this.selectedAreaId = area.id;
        this.selectedAreaText = area.name;
        this.getGangmasterList();
      } else {
        this.partSelectedAreaId = area.id;
        this.partAreaText = area.name;
        this.getForemanList();
      }
      this.isSelectArea = !this.isSelectArea;
    },
  },
};
</script>
<style lang="scss">
// @import "../../../assets/style/supervisor-list.scss";
</style>
